"use strict";
import $ from "jquery";
import _ from "underscore";
import Mousetrap from "mousetrap";
Mousetrap.addKeycodes({
  96: "numpad0",
  97: "numpad1",
  98: "numpad2",
  99: "numpad3",
  100: "numpad4",
  101: "numpad5",
  102: "numpad6",
  103: "numpad7",
  104: "numpad8",
  105: "numpad9",
  106: "numstar",
  107: "numplus",
  109: "numminus"
});
const standardStopCallback = Mousetrap.prototype.stopCallback;
Mousetrap.prototype.stopCallback = function stopCallback(e, element, combo) {
  if ((" " + element.className + " ").indexOf(" mousetrap-allow-text ") > -1) {
    return !(combo.indexOf("alt") >= 0 || combo.indexOf("ctrl") >= 0 || combo === "pagedown" || combo === "pageup");
  }
  return standardStopCallback(e, element, combo);
};
const keysRequiringKeyDownEvent = [
  "numpad0",
  "numpad1",
  "numpad2",
  "numpad3",
  "numpad4",
  "numpad5",
  "numpad6",
  "numpad7",
  "numpad8",
  "numpad9",
  "numstar",
  "numplus",
  "numminus"
];
const bind = (key, event, listener) => {
  const onKey = function() {
    const triggerResult = { handled: false };
    $(listener).trigger("HotkeyEvents:" + event, [triggerResult]);
    if (triggerResult.handled) {
      return false;
    }
  };
  key = _.isArray(key) ? key : [key];
  Mousetrap.bind(
    key.filter((x) => keysRequiringKeyDownEvent.indexOf(x) === -1),
    onKey
  );
  Mousetrap.bind(
    key.filter((x) => keysRequiringKeyDownEvent.indexOf(x) >= 0),
    onKey,
    "keydown"
  );
};
export default {
  listenForKeys: function(keyMap, listener) {
    _.each(keyMap, (keyOrKeys, event) => {
      bind(keyOrKeys, event, listener);
    });
  },
  // intended to be called in componentDidMount
  listenInComponent(component, listener, listenerMap) {
    const hotkeyUnlisteners = [];
    Object.entries(listenerMap).forEach(([eventName, wrappedListenerFn]) => {
      const listenerFn = function(event, triggerResult) {
        triggerResult.handled = true;
        wrappedListenerFn(event, triggerResult);
      };
      $(listener).on(`HotkeyEvents:${eventName}`, listenerFn);
      const unlistenFn = function() {
        $(listener).off(`HotkeyEvents:${eventName}`, listenerFn);
      };
      hotkeyUnlisteners.push(unlistenFn);
    });
    component.setState({
      hotkeyUnlisteners
    });
  },
  // intended to be called in componentWillUnmount
  unlistenInComponent(component) {
    (component.state.hotkeyUnlisteners || []).forEach(
      (unlistenFn) => unlistenFn()
    );
  }
};
